"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSkimTier = exports.SKIM_TIERS = void 0;
exports.parseStartTimeSeconds = parseStartTimeSeconds;
exports.resolveSharedKeypoint = resolveSharedKeypoint;
exports.findKeypointIndex = findKeypointIndex;
exports.resolveInitialTier = resolveInitialTier;
const utils_1 = require("@repo/utils");
exports.SKIM_TIERS = ['short', 'medium', 'relaxed'];
/** Validate an untrusted tier value (route param, query string). */
const parseSkimTier = (value) => exports.SKIM_TIERS.includes(value) ? value : undefined;
exports.parseSkimTier = parseSkimTier;
/**
 * Validate an untrusted `?t=` seconds value. Only whole seconds are links
 * (the website builds them from `timestampToSeconds`); `75abc` or `1.5` are
 * rejected rather than read as a prefix.
 */
function parseStartTimeSeconds(value) {
    if (typeof value !== 'string' || !/^\d+$/.test(value))
        return undefined;
    const parsed = Number(value);
    return Number.isSafeInteger(parsed) ? parsed : undefined;
}
/**
 * Which keypoint a deep link points at: by id first, then (legacy `?t=`
 * links) the keypoint starting exactly at that second, then the one whose
 * window contains it.
 */
function resolveSharedKeypoint(keyPoints, { kp, startTimeSeconds }) {
    const list = keyPoints ?? [];
    if (kp) {
        const byId = list.find((k) => k.id === kp);
        if (byId)
            return byId;
    }
    if (startTimeSeconds === undefined)
        return undefined;
    return (list.find((k) => (0, utils_1.timestampToSeconds)(k.startTimestamp) === startTimeSeconds) ??
        list.find((k) => (0, utils_1.timestampToSeconds)(k.startTimestamp) <= startTimeSeconds &&
            (0, utils_1.timestampToSeconds)(k.endTimestamp) > startTimeSeconds));
}
/** Index of the deep-linked keypoint, or -1 when it is not in the list. */
function findKeypointIndex(keyPoints, target) {
    const match = resolveSharedKeypoint(keyPoints, target);
    return match ? keyPoints.indexOf(match) : -1;
}
/**
 * The tier the analysis opens on. An explicit tier wins: keypoint ids repeat
 * across tier lists, so inferring it from the keypoint's `type` can open the
 * right claim on the wrong tab. The inference stays for legacy links that
 * carry only a keypoint id.
 */
function resolveInitialTier(keyPoints, target) {
    if (target.tier)
        return target.tier;
    if (!target.kp)
        return 'short';
    return keyPoints?.find((k) => k.id === target.kp)?.type ?? 'short';
}
